<template>
    <MainContainer :hideSidebar="true">
        <h2>Versionshinweise</h2>
        <hr />
        <Changelog />
    </MainContainer>
</template>

<script>
// @ is an alias to /src
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Changelog from "@/components/Changelog/Changelog";

export default {
    name: "changelog",
    components: {
        MainContainer,
        Changelog
    },
    data() {
        return {};
    }
};
</script>
